import { useState } from 'react'

interface Props {
  message: string | null
  onSubmit: (token: string) => void
}

/** No user accounts by design: one shared token, stored locally and sent as X-Admin-Token. */
export default function LoginScreen({ message, onSubmit }: Props) {
  const [value, setValue] = useState('')

  return (
    <form
      className="login"
      onSubmit={(event) => {
        event.preventDefault()
        const token = value.trim()
        if (token !== '') onSubmit(token)
      }}
    >
      <h1>Recramap beheer</h1>
      <p>Vul het beheertoken in. Er zijn geen aparte accounts: iedereen die beheert gebruikt hetzelfde token.</p>
      {message && (
        <p className="inline-error" role="alert">
          {message}
        </p>
      )}
      <div className="field">
        <label htmlFor="admin-token">Beheertoken</label>
        <input
          id="admin-token"
          type="password"
          autoComplete="current-password"
          value={value}
          onChange={(event) => setValue(event.target.value)}
        />
      </div>
      <button type="submit" className="btn primary" disabled={value.trim() === ''}>
        Inloggen
      </button>
    </form>
  )
}
